/**
 * NotFoundView — pantalla 404 de la app.
 *
 * Se registra como `defaultNotFoundComponent` del router, así que cubre
 * cualquier URL sin match: typos, links viejos que apuntan a rutas ya
 * removidas, y deep links de correos anteriores a un rename de ruta.
 *
 * Vive dentro del `<Outlet />` del RootLayout, por lo que hereda el
 * shell que corresponda al estado de sesión (FocusedShell sin login,
 * AuthedShell con sidebar/topbar si hay sesión). Por eso el único CTA
 * es "volver al inicio": `/` resuelve a login o dashboard según toque,
 * sin que esta vista tenga que saber cuál de los dos aplica.
 */

import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { ScrollPage } from '../components/shell/ScrollPage'

export function NotFoundView() {
  const { t } = useTranslation('common')

  return (
    <ScrollPage centered>
      <section className="w-full max-w-md rounded-md border border-line bg-surface p-8">
        <p className="font-mono text-xs uppercase tracking-wide text-ink-subtle">
          {t('not_found.code')}
        </p>
        <h1 className="mt-3 font-display text-2xl text-ink">
          {t('not_found.title')}
        </h1>
        <p className="mt-2 font-body text-sm text-ink-muted">
          {t('not_found.body')}
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-md
                     bg-brand px-5 py-2.5 font-ui text-sm text-canvas
                     transition-colors hover:bg-brand-deep
                     focus:outline-none focus:ring-2 focus:ring-brand/40"
        >
          {t('not_found.back_home')}
        </Link>
      </section>
    </ScrollPage>
  )
}
